(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nr-manifesto"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(scope) {
    (scope || document).querySelectorAll('[data-nr-manifesto]').forEach(function (sec) {
      if (sec.__nrRot) { clearInterval(sec.__nrRot); sec.__nrRot = null; }
      var phrases = sec.querySelectorAll('[data-nr-rot] .nr-man__phrase');
      var dots = sec.querySelectorAll('[data-nr-dots] i');
      if (phrases.length < 2) return;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce) return;
      var speed = parseInt(sec.getAttribute('data-speed'), 10) || 2400;
      var i = 0;
      sec.__nrRot = setInterval(function () {
        i = (i + 1) % phrases.length;
        phrases.forEach(function (p, k) { p.classList.toggle('is-on', k === i); });
        if (dots.length) dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      }, speed);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else { init(); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nr-proof-band"] && !Shopify.designMode) return;
  try {
    
(function () {
  function reveal(scope) {
    var els = (scope || document).querySelectorAll('.nr-reveal:not(.is-in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.2, rootMargin: '0px 0px -10% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { reveal(); });
  } else { reveal(); }
  document.addEventListener('shopify:section:load', function (e) { reveal(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
